import { keyframes } from "styled-components";

export const appear = keyframes`
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
`;

export const moving = keyframes`
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(5px);
  }
  75% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const rotate = keyframes`
  0% {
    transform: rotate(0);
  }  
  100% {
    transform: rotate(360deg);
  }
`;

export const rotateLangArrow = keyframes`
  0% {
    transform: rotate(0deg);
  }  
  100% {
    transform: rotate(180deg);
  }
`;

export const appearModal = keyframes`
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
`;
